exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_object-gops.js
// module id = 368
// module chunks = 2